"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var revert_error_1 = require("../../revert_error");
var IllegalReentrancyError = /** @class */ (function (_super) {
    __extends(IllegalReentrancyError, _super);
    function IllegalReentrancyError() {
        return _super.call(this, 'IllegalReentrancyError', 'IllegalReentrancyError()', {}) || this;
    }
    return IllegalReentrancyError;
}(revert_error_1.RevertError));
exports.IllegalReentrancyError = IllegalReentrancyError;
// Register the IllegalReentrancyError type
revert_error_1.RevertError.registerType(IllegalReentrancyError);
//# sourceMappingURL=reentrancy_guard_revert_errors.js.map